import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2CreateDocumentParams,
  IIndirectTaxFilingV2DocumentResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function createIndirectTaxFilingV2Document({
  filingId,
  params,
  token,
}: {
  filingId: string;
  params: IIndirectTaxFilingV2CreateDocumentParams;
  token?: string;
}): Promise<IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2DocumentResponse>> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings-v2/${filingId}/documents`,
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to create filing document',
      };
    }
    const data: IIndirectTaxFilingV2DocumentResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to create filing document',
    };
  }
}
